/**
 * Action menu (kebab dropdown) for an organisation row.
 *
 * Extracted from OrganisationManagementPage.tsx (Sub-PR 6.3).
 */

import { useTranslation } from 'react-i18next'
import { Edit, Shield, ShieldOff, Trash2 } from 'lucide-react'
import type { Organisation } from '../../types'

interface OrganisationActionMenuProps {
  org: Organisation
  onEdit: (org: Organisation) => void
  onDelete: (org: Organisation) => void
  onToggleStatus: (org: Organisation) => void
}

export function OrganisationActionMenu({
  org,
  onEdit,
  onDelete,
  onToggleStatus,
}: OrganisationActionMenuProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div className="absolute right-0 z-10 mt-1 w-48 rounded-lg border border-stone-200 bg-white shadow-lg dark:border-stone-700 dark:bg-stone-800">
      <button
        onClick={() => {
          onEdit(org)
        }}
        className="flex w-full items-center gap-2 px-4 py-2 text-sm text-stone-700 hover:bg-stone-50 dark:text-stone-300 dark:hover:bg-stone-700"
      >
        <Edit className="h-4 w-4" />
        {t('actions.edit')}
      </button>
      <button
        onClick={() => {
          onToggleStatus(org)
        }}
        className="flex w-full items-center gap-2 px-4 py-2 text-sm text-stone-700 hover:bg-stone-50 dark:text-stone-300 dark:hover:bg-stone-700"
      >
        {org.status === 'active' ? (
          <>
            <ShieldOff className="h-4 w-4" />
            {t('users.actions.suspend')}
          </>
        ) : (
          <>
            <Shield className="h-4 w-4" />
            {t('users.actions.activate')}
          </>
        )}
      </button>
      <button
        onClick={() => {
          onDelete(org)
        }}
        className="flex w-full items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20"
      >
        <Trash2 className="h-4 w-4" />
        {t('actions.delete')}
      </button>
    </div>
  )
}
